/**
 * Created by jonas on 2020-11-19.
 */
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Timeline} from "gsap";
import {WinterHoardGameModuleConfig} from "../../WinterHoardGameModuleConfig";

export class BuffaloPickPresentation implements GameRoundPresentation {


    constructor() {

    }


    prepare(data:ParsedServerData) {
        WinterHoardGameModuleConfig.freeSpinIntroView.prepare(data);
    }

    getAnimation(data:ParsedServerData):Timeline | null {
        return <Timeline>WinterHoardGameModuleConfig.freeSpinIntroView.showPickScreen(() => {
            console.log("Needed?");
        }, () => {
            console.log("Dont think this is, needed? Pick event is sent in the presentations anyway");
        });
    }


}